import { Injectable } from '@angular/core';
import { Plugins, NetworkStatus } from '@capacitor/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';

const { Network } = Plugins;
const NETWORK_STATUS_CHANGE_DEBOUNCE_TIME = 2000;

@Injectable({
    providedIn: 'root',
})
export class NetworkStatusService {
    public isNetworkConnected$: Observable<boolean>;
    private _connected$ = new BehaviorSubject<boolean>(true);

    constructor() {
        this.initStartStatus();
        this.initStatusChanges();
        this.isNetworkConnected$ = this._connected$
            .pipe(
                debounceTime(NETWORK_STATUS_CHANGE_DEBOUNCE_TIME),
                distinctUntilChanged(),
            );
    }

    private initStartStatus(): void {
        Network.getStatus().then((status: NetworkStatus) => {
            this._connected$.next(status.connected);
        });
    }

    private initStatusChanges(): void {
        const networkStatusListener = Network.addListener(
            'networkStatusChange',
            (status: NetworkStatus) => {
                this._connected$.next(status.connected);
            },
        );
    }
}
